import { apiProvider } from './provider'


export class ApiCore {
  constructor(options) {
    if (options.getAll) {
      this.getAll = (queryString) => {
        return apiProvider.getAll(options.url, queryString);
      };
    }

    if (options.getSingle) {
      this.getSingle = (id) => {
        return apiProvider.getSingle(options.url, id);
      };
    }

    if (options.post) {
      this.post = (model, queryString) => {
        return apiProvider.post(options.url, model, queryString);
      };
    }

    if (options.put) {
      this.put = (id, model) => {
        return apiProvider.put(options.url, id, model);
      };
    }

    if (options.patch) {
      this.patch = (id, model) => {
        return apiProvider.patch(options.url, id, model);
      };
    }

    if (options.remove) {
      this.remove = (id) => {
        return apiProvider.remove(options.url, id);
      };
    }
  }
}
